<template>
  <b-modal
      id="restrict-platform-modal"
      centered
      size="md"
      v-model="show"
      hide-header-close
      @shown="getPlatformList"
  >
    <b-button variant="close-btn" class='btn-container' @click="closeModal">
      <i class="fas fa-times"></i>
    </b-button>
    <div class="platform-title-text text-center">
      <h5><strong>Restrict Platforms</strong></h5>
    </div>
    <div v-if="filteredPlatforms.length === 0">
      <div :class="{ 'alert alert-danger': errorMsg }">{{errorMsg}} </div>
    </div>
    <form @submit.prevent="updateRestrictPlatform" v-else>
      <div class="platform-note">
        <strong>Note: </strong>
        <p>
          <span class="checked-icon">✔</span> <strong>Checked -</strong> No Access code needed. <br>
          <span class="unchecked-icon">✖</span> <strong> Unchecked -</strong> Access code needed.
        </p>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <b-form-group v-slot="{ ariaDescribedby }">
            <div class="restrict-platform-container">
              <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="selectedPlatforms"
                  :options="filteredPlatforms"
                  :aria-describedby="ariaDescribedby"
                  @change="handleCheckboxChange"
              >
              </b-form-checkbox-group>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row justify-content-end platform-update text-center">
        <div class="col-sm-12">
          <button type="submit" class="univ-btn">Update</button>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Api from "@/resource/Api";
export default {
  props: {
    row: {
      required: true,
    },
  },
  data: () => {
    return {
      show: false,
      platform: [],
      selectedPlatforms: [],
      platformPayload: [],
      errorMsg: ''
    };
  },
  computed: {
    filteredPlatforms () {
      let accessPlatform = this.$endpoint.PLATFORM_RESTRICT_DOMAIN
      const matchedPlatforms = this.platform.filter(
          (platform) => platform.site === accessPlatform
      );
      if (matchedPlatforms.length === 0) {
        return [];
      }
      return matchedPlatforms.map((platformList) => ({
        text: platformList.site,
        value: platformList.site,
      }));
    },
  },
  methods: {
    getPlatformList() {
      this.platform = []
      this.errorMsg = ''
      let url = `v2/get-rep-access?agent_id=${this.row.agent_id}`;
      let loader = this.$loading.show();
      Api.get(url)
          .then((res) => {
            this.platform = res.data.data;
            this.selectedPlatforms = this.platform
                .filter((platform) => platform.status === 1)
                .map((platform) => platform.site);
            this.checkAssignPlan();
          })
          .catch((err) => {
            this.platform = []
            this.errorMsg = ''
            this.errorMsg = err.response.data.message
          })
          .finally(() => {
            loader.hide();
          });
    },
    checkAssignPlan () {
      let accessPlatform = this.$endpoint.PLATFORM_RESTRICT_DOMAIN
      const matchedPlatforms = this.platform.filter(
          (platform) => platform.site === accessPlatform
      );
      if (matchedPlatforms.length === 0) {
        this.errorMsg = 'Goenroll123 group has not been assign.'
        return [];
      }
    },
    handleCheckboxChange(selected) {
      this.platformPayload = this.platform.map((platform) => ({
        platform: platform.site,
        access_type: selected.includes(platform.site) ? 1 : 0,
      }));
    },
    updateRestrictPlatform() {
      let url = `v2/update-rep-access`;
      let data = {
        'agent_id': this.row.agent_id ?  this.row.agent_id : '',
        'platform_type': this.platformPayload ? this.platformPayload : {}
      };
      let loader = this.$loading.show();
      Api.post(url, data)
          .then((res) => {
            this.$notify(res.data.message, "success");
          })
          .catch((err) => {
            this.$notify(err.response.data.message, "error");
          })
          .finally(() => {
            loader.hide();
            this.$bvModal.hide("restrict-platform-modal");
          });
    },
    closeModal() {
      this.$bvModal.hide("restrict-platform-modal");
    },
  },
};
</script>

<style scoped>
.platform-update {
  margin-top: 20px;
}
.platform-title-text {
  margin-bottom: 20px;
}
.custom-control-input {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}
</style>
<style>
#restrict-platform-modal .modal-header,
.modal-footer {
  display: none;
}
#restrict-platform-modal .modal-content {
  border: 0px;
  border-radius: 10px;
}
#restrict-platform-modal .btn-container  {
  position: absolute;
  top: -15px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.platform-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.restrict-platform-container .custom-control-input {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

#restrict-platform-modal input[type="checkbox"]:checked {
  accent-color: #28a745 !important;
}

#restrict-platform-modal .custom-control-label {
  position: relative;
  top: -4px;
}


#restrict-platform-modal .platform-note {
  background-color: #f8f9fa;
  border-left: 5px solid #007bff;
  padding: 10px 15px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #333;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.platform-note strong {
  font-size: 16px;
  color: #0056b3;
}

.platform-note p {
  margin: 5px 0;
}

.checked-icon {
  color: #28a745;
  font-weight: bold;
  margin-right: 5px;
}

.unchecked-icon {
  color: #dc3545;
  font-weight: bold;
  margin-right: 5px;
}
</style>